import React from 'react'
import "./lang.scss"
import { useTranslation } from 'react-i18next'

export default function Lang() {
    const {i18n} = useTranslation(["common"])

    const handleLanguageChange = (e) =>{
        i18n.changeLanguage(e.target.value);
    }
  return (
    
    <div className="language">
      <div className="nv-lang">
        <select name="" id="" className='langSelector' 
        value={localStorage.getItem("i18nextLng")}
        onChange={handleLanguageChange}>
            <option value="es">Español</option>
            <option value="en">English</option>
            <option value="fr">Français</option>
            <option value="ar">العربية</option>
            <option value="zh">中文</option>
            <option value="ru">Русский</option>
            <option value="pt">Português</option>
            <option value="it">Italiano	</option>
        </select>
    </div>
    </div>
  )
}
